<!-- Быстрое создание расхода с главной страницы. -->
<template>
  <HomeQuickActionCard
    label="Добавить расход"
    description="Топливо, оплата, сервис или прочие затраты"
    icon-name="payment"
    color="green"
    :list-to="{ name: 'Expenses' }"
    list-label="Открыть расходы"
    list-subject="расходы"
    @click="showModal = true"
  />

  <Teleport to="body">
    <AddExpensesModal
      v-if="showModal"
      @close="showModal = false"
      @expense-created="showModal = false"
    />
  </Teleport>
</template>

<script>
import AddExpensesModal from "@/components/Expense/AddExpensesModal.vue";
import HomeQuickActionCard from "@/components/Home/QuickActionCard.vue";

export default {
  name: "HomeExpenseAction",

  components: {
    AddExpensesModal,
    HomeQuickActionCard,
  },

  data() {
    return {
      showModal: false,
    };
  },
};
</script>
